import { useCallback, useRef } from "react";
import notificationSound from "../assets/sounds/notification.mp3";
import logger from "../utils/logger";

/**
 * Custom hook to play notification sound
 * Uses the HTML5 Audio API for simple sound playback
 */
export const useNotificationSound = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  // Initialize audio element on first use
  const getAudio = useCallback(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(notificationSound);
      audioRef.current.volume = 0.5; // Set volume to 50%
    }
    return audioRef.current;
  }, []);

  const playSound = useCallback(() => {
    const audio = getAudio();
    // Reset audio to start if already playing
    audio.currentTime = 0;
    audio.play().catch((error) => {
      logger.error("Error playing notification sound:", error);
    });
  }, [getAudio]);

  return { playSound };
};
